<template>
  <vs-prompt buttons-hidden	class="large" :title="data.id ? 'تعديل بنك اسئلة' : 'إضافة بنك اسئلة جديد'"
            :active="active" @close="close">

      <h4 class="mb-6">قم بادخال بيانات بنك الأسئلة</h4>

      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vs-input class="w-full" label="العنوان" v-model="formData.title" placeholder="بنك اسئلة، نموذج اسئلة، موضوع دراسي..."
                    v-validate="'required'"  name="title" data-vv-as="حقل العنوان"/>
          <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div v-if="!data.id" class="vx-col lg:w-1/2 w-full mb-base">
          <label>المادة الدراسية</label>
          <vs-select v-model="formData.course_id" class="w-full vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg">
            <vs-select-item v-for="course in courses" :key="course.id" :value="course.id" :text="`${course.name} (${course.id})`" />
          </vs-select>
        </div>
        <div class="vx-col lg:w-1/2 w-full mb-base">
          <label>خصوصية البنك</label>
          <ul class="flex">
            <li class="mr-2"><vs-radio v-model="formData.type" vs-value="public">مرئي للطلبة</vs-radio></li>
            <li><vs-radio v-model="formData.type" vs-value="private">مخفي عن الطلبة</vs-radio></li>
          </ul>
        </div>
      </div>

      <vs-divider />
      <div class="flex justify-end">
        <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
        <vs-button @click="submitClicked">حفظ</vs-button>
      </div>
  </vs-prompt>
</template>
<script>
    export default {
        name: 'QuestionsBankForm',
        props: {
            data: {
                type: Object,
                default: () => {}
            },
            active: {
                type: Boolean,
                required: true
            },
        },
        watch: {
            active(val){
                if(!val) return

                this.intiValues()

                if(this.data.id) Object.assign(this.formData, this.data)
            }
        },
        data() {
            return {
                courses: [],
                formData: {
                    title: '',
                    course_id: '',
                    is_current_term: true,
                    type: 'public',
                }
            }
        },
        methods: {
            submitClicked(){
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        if(this.data.id) {
                            this.update()
                        } else {
                            this.add()
                        }
                    }
                })
            },
            add(){
                this.formData.course = this.courses[this.formData.course_id].name
                this.$store.dispatch("questionBanks/create",this.formData)
                    .then(response => {
                        this.$notifySuccess(response.successMessage)
                        this.$closeLoading()
                        this.close()
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            update(){
                this.$store.dispatch("questionBanks/update", this.formData)
                    .then(response => {
                        this.$notifySuccess(response.successMessage)
                        this.$closeLoading('#qbForm')
                        this.close()
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            close(){
                this.$emit('update:active', false)
            },
            intiValues(){
                this.formData = {
                    title: '',
                    is_current_term: true,
                    course_id: Object.values(this.courses)[0].id,
                    type: 'public',
                }
                this.$validator.reset()
            },
        },
        mounted(){
            this.courses = this.$store.state['courses']['all']
        }
    }
</script>
